// extracted by mini-css-extract-plugin
export default {"btn":"ButtonSave_btn__BxqFJ","btn__text":"ButtonSave_btn__text__tKVy7","btn__icon":"ButtonSave_btn__icon__+CapJ","grow":"ButtonSave_grow__8YVRF"};